// entire words only: (yes|no). case insensitive
export const yesOrNoRegexp = new RegExp(/(\byes\b|\bno\b)/, 'gim');
